import { render } from "./setup-controls.vue?vue&type=template&id=3af2f361"
import script from "./setup-controls.vue?vue&type=script&lang=js"
export * from "./setup-controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__